var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBody1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Female_x5F_skins:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "skin_x5F_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9B187",
    d: "M352.8,108.4c16.2,0,31.7,0.9,47,6.3c13.7,4.8,28.5,13.6,37.9,24.9c20.3,24.4,25.5,59.4,21.4,90.3 c-2.1,15.7-4.5,31.4-5.6,47.2c-1.2,16.8-1.7,33.9-5.5,50.4c-7.2,31.3-30.1,55.6-55.3,73.9c-13.4,9.7-27.2,13.8-43.6,12.2 c-14.4-1.4-28.4-12.2-38.5-21.9c-12-11.5-21.9-23.8-30.8-37.8c-8.7-13.8-12.6-29.3-14.5-45.3c-3.9-31.7-8.3-63.7-8.3-95.6 c0-16.2,2.6-31.6,7.9-46.9c5.6-16.5,15.5-27.4,28.7-38.3C308.8,114.9,333.2,108.4,352.8,108.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9B187",
    d: "M590,549.7c-4-13.6-8.1-26.7-17.4-37.5c-5.1-5.9-12-9.1-16.4-12c-5.1-3.3-11.3-5.2-17-7.4 c-29.8-11.3-61.8-17.5-89.9-32.9c-27.9-15.3-28.7-54.7-28.7-83.1c-8.4,9.2-18,17.3-28,24.6c-13.4,9.7-27.2,13.8-43.6,12.2 c-14.4-1.4-28.4-12.2-38.5-21.9c-5.8-5.6-11.2-11.4-16.2-17.5c0,28.7-0.7,70.5-28.7,85.8c-28.2,15.4-60.1,21.6-89.9,32.9 c-5.6,2.1-11.9,4.1-17,7.4c-4.5,2.9-11.4,6.2-16.4,12c-9.3,10.8-13.1,22-17.1,35.6c-7,23.8-5.6,54-5.3,79.9 c63.7,57.3,148,92.1,240.4,92.1c93,0,177.7-35.3,241.5-93.2C600,600.6,597.3,574.8,590,549.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E59B70",
    d: "M456,252.2c-1.1,8.2-2,16.5-2.6,24.7c-1,14.2-1.6,28.6-4,42.7c0.1,0,0.1,0,0.2,0 c13.8,0.2,12.2-15.1,14.4-24.8c2.3-10.3,7.7-19.2,8.3-30.1C472.9,254.2,464.7,246.8,456,252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E59B70",
    d: "M258.6,251.3c-8-3.5-15.1,3.6-14.5,13.3c0.6,10.9,6,19.8,8.3,30.1c2.2,9.8,0.5,25,14.4,24.8 c0,0,0,0,0.1,0c-0.7-3.7-1.3-7.4-1.8-11.2C262.8,289.4,260.3,270.4,258.6,251.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC865D",
    d: "M461.5,269.6c-5.1,9.5-5.3,18.7-5.1,29.3c0,1,1.6,0.9,1.6-0.3c-0.2-11,0.3-20.5,5.3-29.7 C463.7,268,462.5,268.1,461.5,269.6L461.5,269.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC865D",
    d: "M454.2,267.8c-0.3,3-0.6,6.1-0.8,9.1c-1,14.2-1.6,28.6-4,42.7c0.1,0,0.1,0,0.2,0c0.6,0,1.1,0,1.6-0.1 C453.8,305,454.6,282.1,454.2,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC865D",
    d: "M260.4,269.4c0.2,14.7,1.7,36.5,4.8,50.1c0.5,0,1,0.1,1.6,0.1c0,0,0,0,0.1,0c-0.7-3.7-1.3-7.4-1.8-11.2 C263.5,295.4,261.9,282.5,260.4,269.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC865D",
    d: "M252.6,273.5c5.3,9.3,5.9,18.5,6.1,29.1c0,1-1.6,0.9-1.6-0.3c-0.1-11-1-20.4-6.2-29.5 C250.3,271.9,251.6,272,252.6,273.5L252.6,273.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC865D",
    d: "M492.8,595.2c-1.9,0.5-9.6,2-6.3,5.7c1.6,1.8,13.4,0.6,16.5,0.4c15.3-1.1,26.8-2.8,42-4.3 c17.8-1.8,35.6-3.8,53.3-6.1c-0.7-5.2-1.5-10.4-2.4-15.6c-27.6,4.2-55.1,9.2-82.4,15.2C506.6,591.9,499.6,593.2,492.8,595.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC865D",
    d: "M308.4,392.5c8.7,7.6,17.1,15.3,27.4,20.4c10.4,5.1,21.6,7.3,33.3,7.7c11.4,0.3,23.1-0.4,34.4-2.1 c5.9-0.9,12.7-2.8,19.1-5c-1.9-12.5-2-25.5-2-36.8c-8.4,9.2-18,17.3-28,24.6c-13.4,9.7-27.2,13.8-43.6,12.2 c-14.4-1.4-28.4-12.2-38.5-21.9c-5.8-5.6-11.2-11.4-16.2-17.5c0,0.8,0,1.5,0,2.3C298.5,382.3,304.2,388.8,308.4,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC865D",
    d: "M209.4,611.6c4-0.4,8-1.1,11.9-2c5-1.2,2.5-4.5-0.9-5.3c-7.7-1.9-15.7-2.7-23.6-3.5 c-27.2-2.7-52.1-2.8-77.3-2.5c0,5.6,0,11.2,0.1,16.7c13.2-0.1,26.4-0.1,39.6-0.5C176,614,192.7,613.2,209.4,611.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody1B);
export default __webpack_public_path__ + "static/media/body_1b.69bfedfc1b466042d8c177c6441c1181.svg";
export { ForwardRef as ReactComponent };